// File: Invoices.js
import api from "./Axios.js";

export async function getClientInvoices(params) {
    const response = await api.get('invoices', { params })
    return response.data
}
